import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  filterByClassificator: false,
  classificatorGroupId: 4352,
  onlyActive: true,
  restaurantId: 0,
  restaurants: [],
  restaurantsFailed: false,

  presentCategoryIds: [],
  applianceCategoryIds: [],
  categories: [],
  categoriesFailed: false,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')

    return systemSettingApi.getMenuSyncSetting()
      .then(({ data }) => commit('MENU_SYNC_SETTING_FETCHED', data))
      .catch(err => commit('MENU_SYNC_SETTING_FETCH_FAILED', err))
  },
  fetchRestaurants({ commit }) {
    return systemSettingApi.getMenuSyncRestaurants()
      .then(({ data }) => commit('MENU_SYNC_RESTAURANTS_FETCHED', data))
      .catch(() => commit('MENU_SYNC_RESTAURANTS_FAILED'))
  },
  fetchCategories({ commit }) {
    return systemSettingApi.getMenuSyncCategories()
      .then(({ data }) => commit('MENU_SYNC_CATEGORIES_FETCHED', data))
      .catch(() => commit('MENU_SYNC_CATEGORIES_FAILED'))
  },
  update({ commit }) {
    return systemSettingApi.updateMenuSyncSetting({
      filterByClassificator: state.filterByClassificator,
      classificatorGroupId: Number(state.classificatorGroupId),
      onlyActive: state.onlyActive,
      restaurantId: Number(state.restaurantId),
      presentCategoryIds: state.presentCategoryIds,
      applianceCategoryIds: state.applianceCategoryIds,
    })
      .then(({ data }) => commit('MENU_SYNC_SETTING_UPDATED', data))
      .catch(error => {
        commit('MENU_SYNC_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  MENU_SYNC_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  MENU_SYNC_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  MENU_SYNC_SETTING_FETCH_FAILED() {
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    const fresh = getDefaultState()

    fresh.categories = state.categories
    fresh.categoriesFailed = state.categoriesFailed
    Object.assign(state, fresh)
  },
  MENU_SYNC_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  MENU_SYNC_RESTAURANTS_FETCHED(state, data) {
    state.restaurants = data
    state.restaurantsFailed = false
  },
  MENU_SYNC_RESTAURANTS_FAILED(state) {
    state.restaurants = []
    state.restaurantsFailed = true
  },
  MENU_SYNC_CATEGORIES_FETCHED(state, data) {
    state.categories = data
    state.categoriesFailed = false
  },
  MENU_SYNC_CATEGORIES_FAILED(state) {
    state.categories = []
    state.categoriesFailed = true
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
